export const ADD_CAR_DATA = 'ADD_CAR_DATA';
export const UPDATE_CAR_DATA = 'UPDATE_CAR_DATA';
export const ADD_CAR_DATA_MAIN = 'ADD_CAR_DATA_MAIN';
export const ADD_DAMAGE_DATA_MAIN = 'ADD_DAMAGE_DATA_MAIN';
export const UPDATE_IMAGES_ = 'UPDATE_IMAGES_';

